import type {
  LogoutRequest,
  RefreshTokenRequest,
  RefreshTokenResponse,
  RuntimeTokenReponse,
  RuntimeTokenRequest,
  SignInRequest,
  SignInResponse,
} from "../types";
import { rootApi } from "../../../api";

const authApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<SignInResponse, SignInRequest>({
      query: (body) => ({
        url: "auth/sign-in",
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["auth"],
    }),
    refreshToken: build.mutation<RefreshTokenResponse, RefreshTokenRequest>({
      query: (body) => ({
        url: "auth/refresh-token",
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["auth"],
    }),
    runtimeToken: build.query<RuntimeTokenReponse, RuntimeTokenRequest>({
      query: () => ({
        url: "auth/runtimeToken",
        method: "GET",
      }),
      providesTags: ["auth"],
    }),
    logout: build.mutation<void, LogoutRequest>({
      query: (body) => ({
        url: "auth/logout",
        method: "POST",
        body,
        responseHandler: "text",
      }),
    }),
    heartbeat: build.query<void, void>({
      query: () => ({
        url: "settings/profile",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLazyHeartbeatQuery,
  useLogoutMutation,
  useRefreshTokenMutation,
  useRuntimeTokenQuery,
  useLazyRuntimeTokenQuery,
} = authApi;
